import useApi from '../../components/js/Composables/useApi'
import type { FormDef } from '../../Types/form'
import type { TotpSetup } from '../../Types/user'

export default function useTotpApi() {
  const { getJSON, postJSON } = useApi()

  async function getDef(): Promise<{ config: FormDef; object: TotpSetup }> {
    return await getJSON('users/totp/def')
  }

  async function setup(code: string) {
    await postJSON('users/totp/setup', { code })
  }

  return {
    getDef,
    setup,
  }
}
